import styled from "styled-components";


export const Container = styled.div`
    display:flex;
    justify-content: center;
    align-items: center;
    width: 150px;
    height: 150px;
    @media (min-width: 720px) {
        width: 200px;
        height: 200px;
    }
    @media (orientation: landscape) and (max-width: 1080px){
        width: 150px;
        height: 150px;
    }
`;